import classNames from 'classnames';
import Image from 'next/image';
import PropTypes from 'prop-types';

import classes from './index.module.css';

const Content = ({ title, value, icon, alt, isInteractive, isTimeline }) => (
  <>
    <div>
      {title && (
        <div className={classNames("text-capitalize", classes.title, { [classes.interactive]: isInteractive, [classes.timeline] : isTimeline }, )}>
          {title}
        </div>
      )}
      {value && (
        <div className={classNames('text-capitalize z-font-20 z-font-600 z-mt-2 z-mb-4', classes.value)}>
          {value}
        </div>
      )}
    </div>
    {icon && (
      <div className={classNames('d-flex align-items-center justify-content-center', classes.icon)}>
        <Image
          layout="fixed"
          width={60}
          height={60}
          src={icon}
          alt={alt || title}
          placeholder="blur"
          blurDataURL="/ui-router/images/placeholder.png"
        />
      </div>
    )}
  </>
);

Content.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.node,
  icon: PropTypes.string,
  alt: PropTypes.string,
  isInteractive: PropTypes.bool,
  isTimeline: PropTypes.bool,
};

Content.defaultProps = {
  title: '',
  value: '',
  icon: '',
  alt: '',
  isInteractive: false,
  isTimeline: false,
};

export default Content;
